import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform(value: any, args: any[]): string {
    if (isNaN(value)) {
      return value;
    }
    return (isNaN(parseFloat(value)) && isNaN(+value)) ? value : parseFloat(value).toFixed(3);
  }

}
